import { useRef, useState } from "react";
import { cognitoUserInfo } from "../helpers/userHelper";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { usePromiseEffect } from "../helpers/promiseEffect";
import ICurrentUser from "../entities/helper/ICurrentUser";
import { Overlay, Popover } from "react-bootstrap";
import { Auth } from "aws-amplify";
import { ENV } from "../helpers/variableHelper";
interface INavigation {
  cur?: ICurrentUser;
}
const Navigation = ({ cur }: INavigation) => {
  const [currentUser, setCurrentUser] = useState<ICurrentUser | undefined>(cur);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  usePromiseEffect(async () => {
    let currUser: ICurrentUser = await cognitoUserInfo();
    setCurrentUser(cur !== undefined ? cur : currUser);
  }, []);

  interface ItemListaMantenible {
    key: string;
    value: string;
    url: string;
    childrens?: Array<ItemListaMantenible>;
  }
  const tipo_causas_inmediatas: Array<ItemListaMantenible> = [
    {
      key: "TipoCausaInmediata",
      value: "Tipo causa inmediata",
      url: "/administracion/mantenedor/tipocausainmediata",
    },
    {
      key: "ActoCondicionEstandar",
      value: "Acto condición subestándar",
      url: "/administracion/mantenedor/actocondicionsubestandar",
    },
  ];

  const tipo_causa_basica: Array<ItemListaMantenible> = [
    {
      key: "TipoCausaBasica",
      value: "Tipo causa básica",
      url: "/administracion/mantenedor/tipocausabasica",
    },
    {
      key: "FactoresPersonales",
      value: "Factores personales",
      url: "/administracion/mantenedor/factorespersonales",
    },
    {
      key: "Capacidades",
      value: "Capacidades",
      url: "/administracion/mantenedor/capacidades",
    },
  ];

  const tipo_causas_sistema: Array<ItemListaMantenible> = [
    {
      key: "RequisitoSistema",
      value: "Ámbitos de Gestión",
      url: "/administracion/mantenedor/requisitosistema",
    },
  ];

  const administracion: Array<ItemListaMantenible> = [
    {
      key: "UsuariosExternos",
      url: "/administracion/usuarios/externos",
      value: "Usuarios externos",
    },
    //{ key: "Roles", url: "/administracion/usuarios/roles", value: "Roles" },
    {
      key: "RolesUsuarios",
      url: "/administracion/usuarios/rolesusuario",
      value: "Roles usuarios",
    },
    {
      key: "ArbolCausa",
      url: "/administracion/arbolcausal",
      value: "Árbol Causal",
    },
    {
      key: "Mantenedores",
      value: "Mantenedores",
      url: "#",
      childrens: [
        {
          key: "mantdeviaciones",
          value: "Mant. Desviaciones",
          url: "#",
          childrens: [
            {
              key: "mantenedordeviaciones",
              value: "Desviaciones",
              url: "/administracion/mantenedordesviacion",
            },
            {
              key: "mantenedorcausas",
              value: "Causas",
              url: "/administracion/mantenedorcausas",
            },
          ],
        },
        {
          key: "mantlio",
          value: "Mant. Ins/Obs",
          url: "#",
          childrens: [
            {
              key: "mantenedorio",
              value: "Inspecciones/Observaciones",
              url: "/administracion/mantenedorio",
            },
            {
              key: "mantenedorioaspectos",
              value: "Aspectos a Evaluar",
              url: "/administracion/mantenedorioaspectos",
            },
          ],
        },
        {
          key: "mantauditoria",
          value: "Mant. Auditoría",
          url: "#",
          childrens: [
            {
              key: "mantenedorauditoria",
              value: "Auditoría",
              url: "/administracion/mantenedorauditoria",
            },
            {
              key: "mantenedoritem",
              value: "Ítem Normativa",
              url: "/administracion/mantenedoritem",
            },
          ],
        },
        {
          key: "mantproveedores",
          value: "Mant. Proveedores",
          url: "#",
          childrens: [
            {
              key: "mantenedorprogramasanuales",
              value: "Programas Anuales",
              url: "/administracion/mantenedorprogramasanuales",
            },
            {
              key: "mantenedorcplanificaciones",
              value: "Planificaciones",
              url: "/administracion/mantenedorplanificaciones",
            },
            {
              key: "mantenedormedidas",
              value: "Medidas",
              url: "/administracion/mantenedormedidas",
            },
          ],
        },
        {
          key: "historialcambios",
          url: "/administracion/historialcambios",
          value: "Historial de Cambios",
        },
        {
          key: "registrosdesactivados",
          url: "/administracion/mantenedorregistrosdesactivados",
          value: "Mantenedor Registros Desactivados",
        },
      ],
    },
  ];

  const listasMantenibles: Array<ItemListaMantenible> = [
    {
      key: "Vicepresidencia",
      value: "Vicepresidencia",
      url: "/administracion/mantenedor/vicepresidencia",
    },
    {
      key: "Gerencia",
      value: "Gerencia",
      url: "/administracion/mantenedor/gerencia",
    },
    {
      key: "Unidad",
      value: "Unidad",
      url: "/administracion/mantenedor/unidad",
    },
    {
      key: "Contrato",
      value: "Contrato",
      url: "/administracion/mantenedor/contrato",
    },
    {
      key: "ContratistasSubContratistas",
      value: "Contratistas SubContratistas",
      url: "/administracion/mantenedor/contratistasubcontratista",
    },
    {
      key: "ContratistasResponsables",
      value: "Contratistas - Responsables",
      url: "/administracion/mantenedor/contratistasresponsables",
    },
    {
      key: "RequisitosNormativos",
      value: "Requisitos Normativos",
      url: "/administracion/mantenedor/requisitosnormativos",
    },
    {
      key: "Notificaciones",
      value: "Notificaciones",
      url: "/administracion/mantenedor/notificaciones",
    },
    {
      key: "GravedadPotencial",
      value: "Gravedad Potencial",
      url: "/administracion/mantenedor/gravedadpotencial",
    },
    {
      key: "AmbitoDesviacion",
      value: "Ámbito Desviación",
      url: "/administracion/mantenedor/ambitodesviacion",
    },
    {
      key: "TipoDesviacion",
      value: "Tipo Desviación",
      url: "/administracion/mantenedor/tipodesviacion",
    },
    { key: "", value: "", url: "" },
    {
      key: "CausasBasicas",
      value: "Causas básicas",
      url: "#",
      childrens: tipo_causa_basica,
    },
    {
      key: "CausasInmediatas",
      value: "Causas inmediatas",
      url: "#",
      childrens: tipo_causas_inmediatas,
    },
    {
      key: "CausasSistema",
      value: "Causas Sistema",
      url: "#",
      childrens: tipo_causas_sistema,
    },
  ];
  const listasManteniblesProveedores: Array<ItemListaMantenible> = [
    {
      key: "arearesponsable",
      value: "Área responsable",
      url: "/administracion/mantenedor/arearesponsable",
    },
    {
      key: "parametros",
      value: "Parámetros",
      url: "/administracion/mantenedor/parametros",
    },
    {
      key: "tipoproceso",
      value: "Tipo de proceso",
      url: "/administracion/mantenedor/tipoproceso",
    },
    {
      key: "producto",
      value: "Productos",
      url: "/administracion/mantenedor/producto",
    },
    {
      key: "proveedor",
      value: "Proveedor",
      url: "/administracion/mantenedor/proveedor",
    },
  ];
  const listasManteniblesLIO: Array<ItemListaMantenible> = [
    {
      key: "Aspecto",
      value: "Aspecto",
      url: "/administracion/mantenedor/aspecto",
    },
    {
      key: "TipoEvaluacion",
      value: "Tipo Evaluación",
      url: "/administracion/mantenedor/tipoevaluacion",
    },
    {
      key: "LIOInspectorTranselec",
      value: "Inspeccionado por",
      url: "/administracion/mantenedor/lioinspectortranselec",
    },
    {
      key: "LIOPrevencionista",
      value: "Empresa Inspectora",
      url: "/administracion/mantenedor/lioprevencionista",
    },
    { key: "Faena", value: "Lista", url: "/administracion/mantenedor/faena" },
    {
      key: "TipoFaena",
      value: "Tipo Lista",
      url: "/administracion/mantenedor/tipofaena",
    },
  ];

  const listasManteniblesAuditoria: Array<ItemListaMantenible> = [
    {
      key: "tipoauditoria",
      value: "Tipo Auditoría",
      url: "/administracion/mantenedor/tipoauditoria",
    },
    {
      key: "tipounidadauditar",
      value: "Ámbito de Auditoría",
      url: "/administracion/mantenedor/tipounidadauditar",
    },
    {
      key: "tipoalcance",
      value: "Tipo Alcance",
      url: "/administracion/mantenedor/tipoalcance",
    },
  ];

  return (
    <>
      <Navbar collapseOnSelect expand="lg" bg="transparent" variant="dark">
        <Container className="inicio mt-4">
          <Navbar.Brand href="/" className={`bi bi-house-door-fill textInicio ${window.location.href === window.location.origin + "/" && "active"}`}>
            {" "}
            Inicio
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          {currentUser?.email && (
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                {!currentUser?.external && (
                  <NavDropdown
                    title="Desviaciones"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${window.location.href.indexOf("/desviacion") > -1 && "active"}`}>
                    <NavDropdown.Item href="/desviacion">Home</NavDropdown.Item>
                    <NavDropdown.Item href="/desviacionhistorico">Histórico</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      href="https://app.powerbi.com/view?r=eyJrIjoiOGUwZTVmZWQtNzNlZC00ODczLThjY2EtNDRhYzg5M2Q5MzNmIiwidCI6IjdmNDA1OTRhLWRiYzQtNGMxNC04ZGE2LTk3YTJhY2VkNDI4ZSIsImMiOjR9"
                      target="_blank">
                      Reporte BI
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/desviacionreporte">Reporte - Desviaciones</NavDropdown.Item>
                    <NavDropdown.Item href="/desviacionreporteac">Reporte - Análisis Causal</NavDropdown.Item>
                    <NavDropdown.Item href="/desviacionreportesabana">Reporte - Sábana Desviaciones</NavDropdown.Item>
                  </NavDropdown>
                )}
                {(currentUser?.external ? currentUser.roles.IS_EXT_LIO : true) && (
                  <NavDropdown
                    title="Inspección y Observación"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${window.location.href.indexOf("lio") > -1 && "active"}`}>
                    <NavDropdown.Item href="/lio">Home</NavDropdown.Item>
                    <NavDropdown.Item href="/gestionarLIO">Gestionar LIO</NavDropdown.Item>
                    {!currentUser?.external && currentUser.roles.IS_ADMIN && (
                      <NavDropdown.Item href="/mantenedorLIO">Mantenedor de LIO</NavDropdown.Item>
                    )}
                    {!currentUser?.external && (
                      <>
                        <NavDropdown.Item href="/historicoLIO">Histórico LIO</NavDropdown.Item>
                        <NavDropdown.Item
                          href="https://app.powerbi.com/view?r=eyJrIjoiMTVjYmY5ZjQtNDk1ZC00NGE5LWFkYTQtMzMzZWE3OTFmYjFjIiwidCI6IjdmNDA1OTRhLWRiYzQtNGMxNC04ZGE2LTk3YTJhY2VkNDI4ZSIsImMiOjR9"
                          target="_blank">
                          Reporte BI
                        </NavDropdown.Item>
                      </>
                    )}
                    <NavDropdown title="Reportes" id="collasible-nav-dropdown" className="listaMantenible btn btn-sm p-1 me-2 pb-0">
                      {!currentUser?.external && (
                        <>
                          <NavDropdown.Item href={`/reporteLIO`}>Inspecciones</NavDropdown.Item>
                          <NavDropdown.Item href={`/reporteEtapasDecisionesLIO`}>Etapas y Decisiones</NavDropdown.Item>
                        </>
                      )}
                      <NavDropdown.Item href={`/reporteSabanaLIO`}>Sábana LIO</NavDropdown.Item>
                    </NavDropdown>
                  </NavDropdown>
                )}

                {!currentUser?.external && (
                  <NavDropdown
                    title="Auditoría"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${window.location.href.indexOf("auditoria") > -1 && "active"}`}>
                    <NavDropdown.Item href="/auditoria/home">Home</NavDropdown.Item>
                    <NavDropdown.Item href="/auditoria/historico">Histórico Auditoría</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      href="https://app.powerbi.com/view?r=eyJrIjoiMzdiOTk2NzYtMjI1Mi00YjA3LThjNTEtZDZjYTc5NmI4NDBlIiwidCI6IjdmNDA1OTRhLWRiYzQtNGMxNC04ZGE2LTk3YTJhY2VkNDI4ZSIsImMiOjR9"
                      target="_blank">
                      Reporte BI
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/auditoria/reportesabana">Reporte sábana</NavDropdown.Item>
                  </NavDropdown>
                )}

                {(currentUser?.external ? currentUser.roles.IS_EXT_PROVEEDORES : true) && (
                  <NavDropdown
                    title="Proveedores"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${window.location.href.indexOf("proveedores") > -1 && "active"}`}>
                    <NavDropdown.Item href="/proveedores/home">Home</NavDropdown.Item>
                    {!currentUser?.external && (
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/proveedores/sabana">Reporte proveedor</NavDropdown.Item>
                      </>
                    )}
                  </NavDropdown>
                )}

                {!currentUser?.external && currentUser.roles.IS_ADMIN && (
                  <NavDropdown
                    title="Listas mantenibles"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${window.location.href.indexOf("/administracion/mantenedor/") > -1 && "active"}`}>
                    <NavDropdown title="Globales" id="collasible-nav-dropdown" className="listaMantenible btn btn-sm p-1 me-2 pb-0">
                      {listasMantenibles.map((i) => {
                        return i.childrens ? (
                          <NavDropdown key={i.key} title={i.value} className="dropdown-item drop-item-text">
                            {i.childrens.map((c) => {
                              return (
                                <NavDropdown.Item key={c.key} href={`${c.url}`}>
                                  {c.value}
                                </NavDropdown.Item>
                              );
                            })}
                          </NavDropdown>
                        ) : (
                          <NavDropdown.Item key={i.key} href={`${i.url}`}>
                            {i.value}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                    <NavDropdown title="Proveedores" id="collasible-nav-dropdown" className="listaMantenible btn btn-sm p-1 me-2">
                      {listasManteniblesProveedores.map((i) => {
                        return i.childrens ? (
                          <NavDropdown key={i.key} title={i.value} className="dropdown-item drop-item-text">
                            {i.childrens.map((c) => {
                              return (
                                <NavDropdown.Item key={c.key} href={`${c.url}`}>
                                  {c.value}
                                </NavDropdown.Item>
                              );
                            })}
                          </NavDropdown>
                        ) : (
                          <NavDropdown.Item key={i.key} href={`${i.url}`}>
                            {i.value}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                    <NavDropdown title="LIO" id="collasible-nav-dropdown" className="listaMantenible btn btn-sm p-1 me-2 pb-0">
                      {listasManteniblesLIO.map((i) => {
                        return i.childrens ? (
                          <NavDropdown key={i.key} title={i.value} className="dropdown-item drop-item-text">
                            {i.childrens.map((c) => {
                              return (
                                <NavDropdown.Item key={c.key} href={`${c.url}`}>
                                  {c.value}
                                </NavDropdown.Item>
                              );
                            })}
                          </NavDropdown>
                        ) : (
                          <NavDropdown.Item key={i.key} href={`${i.url}`}>
                            {i.value}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                    <NavDropdown title="Auditoría" id="collasible-nav-dropdown" className="listaMantenible btn btn-sm p-1 me-2">
                      {listasManteniblesAuditoria.map((i) => {
                        return i.childrens ? (
                          <NavDropdown key={i.key} title={i.value} className="dropdown-item drop-item-text">
                            {i.childrens.map((c) => {
                              return (
                                <NavDropdown.Item key={c.key} href={`${c.url}`}>
                                  {c.value}
                                </NavDropdown.Item>
                              );
                            })}
                          </NavDropdown>
                        ) : (
                          <NavDropdown.Item key={i.key} href={`${i.url}`}>
                            {i.value}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                  </NavDropdown>
                )}
                {!currentUser?.external && currentUser.roles.IS_ADMIN && (
                  <NavDropdown
                    title="Administración"
                    id="collasible-nav-dropdown"
                    className={`text-white btn btn-sm p-1 me-2 ${
                      window.location.href.indexOf("/administracion") > -1 &&
                      window.location.href.indexOf("/administracion/mantenedor/") === -1 &&
                      "active"
                    }`}>
                    {administracion.map((i) => {
                      return i.childrens ? (
                        <NavDropdown key={i.key} title={i.value} className="dropdown-item drop-item-text">
                          {i.childrens.map((c) => {
                            if (c.childrens) {
                              return (
                                <NavDropdown
                                  key={c.key}
                                  title={c.value}
                                  id="collasible-nav-dropdown"
                                  className="listaMantenible btn btn-sm p-1 me-2 pb-0">
                                  {c.childrens.map((s) => {
                                    return (
                                      <NavDropdown.Item key={s.key} href={`${s.url}`}>
                                        {s.value}
                                      </NavDropdown.Item>
                                    );
                                  })}
                                </NavDropdown>
                              );
                            } else {
                              return (
                                <NavDropdown.Item key={c.key} href={`${c.url}`}>
                                  {c.value}
                                </NavDropdown.Item>
                              );
                            }
                          })}
                        </NavDropdown>
                      ) : (
                        <NavDropdown.Item key={i.key} href={`${i.url}`}>
                          {i.value}
                        </NavDropdown.Item>
                      );
                    })}
                  </NavDropdown>
                )}
              </Nav>
            </Navbar.Collapse>
          )}
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text className="p-0 lh-1">
              <label>
                <small>{ENV}</small>
              </label>
              {currentUser?.email && (
                <>
                  <label className="d-block">
                    <small>Bienvenido:</small>
                  </label>
                  <small ref={ref}>
                    {" "}
                    <a
                      data-testid="testhref"
                      href="#"
                      title={currentUser?.email}
                      onClick={(event: any) => {
                        setShow(!show);
                        setTarget(event.target);
                      }}>
                      {currentUser?.fullname ? currentUser.fullname : currentUser?.email}
                    </a>
                  </small>
                </>
              )}
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Overlay show={show} target={target} placement="bottom" container={ref} containerPadding={20}>
        <Popover id="popover-contained">
          <Popover.Body>
            <button
              className="btn btn-primary"
              onClick={async (e) => {
                await Auth.signOut();
                window.location.reload();
              }}>
              Cerrar sesión
            </button>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};

export default Navigation;
